/**
 * Replace BE-side `"User"` fallback (the generic `ChatDisplayNameFactory.GenericFallback`)
 * with a per-user friendly alias derived from the user id, so chat surfaces don't
 * show a wall of identical "User" rows for accounts that registered via plain
 * email before the registration flow learned to seed a default DisplayName.
 *
 * The BE uses `"User"` whenever `AppUser.DisplayName` is null/empty — falling
 * back to the email/UserName would leak PII (UserName equals Email in our
 * Identity setup). New email registrations now seed `DisplayName = "Гость XXXX"`
 * server-side; this helper covers everyone who registered before that change
 * landed without needing a backfill migration.
 *
 * Output is deterministic per user id, so the same person reads as the same
 * "Гость …" across messages and reload.
 */
const GENERIC_FALLBACK = 'User';

function suffixFromId(userId: string | null | undefined): string {
    if (!userId) return '????';
    const compact = userId.replace(/-/g, '');
    return (compact.length >= 4 ? compact.slice(0, 4) : compact.padEnd(4, '0')).toUpperCase();
}

export function safeDisplayName(rawName: string | null | undefined, userId: string | null | undefined): string {
    const trimmed = (rawName ?? '').trim();
    if (trimmed === '' || trimmed === GENERIC_FALLBACK) {
        return `Гость ${suffixFromId(userId)}`;
    }
    return trimmed;
}
